import React from 'react';
import {
  View,
  StyleSheet,
  Document,
  Text,
  Page,
  Font,
} from '@react-pdf/renderer';
import Item from './Components/Item';
import RadioTable from './Components/RadioTable';
import { primaryColorDark } from './Components/PDFStyles';
import black from './Fonts/RedHatDisplay-Black.ttf';
import bold from './Fonts/RedHatDisplay-Bold.ttf';
import medium from './Fonts/RedHatDisplay-Medium.ttf';
import regular from './Fonts/RedHatDisplay-Regular.ttf';

const styles = StyleSheet.create({
  pageNumber: {
    position: 'absolute',
    fontSize: 14,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: primaryColorDark,
    fontWeight: 700,
  },
  page: {
    paddingTop: 60,
    paddingBottom: 55,
  },
  subHeader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
  image: {
    width: '33%',
    paddingTop: 15,
    paddingLeft: 10,
  },
  icon: {
    width: '17px',
    height: '17px',
  },
  iconRowView: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    height: '30px',
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 18,
  },
  iconText: {
    color: primaryColorDark,
    fontWeight: 400,
    fontSize: 11,
    paddingLeft: 5,
    paddingTop: 3,
  },
  body: {
    marginTop: '30px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});

export const JPDF = ({
  header,
  assessments,
  document = true,
  debug = false,
}: {
  header?: JSX.Element;
  assessments: any;
  document?: boolean;
  debug?: boolean;
}) => {
  const JPDFContent = () => (
    <View style={header ? styles.body : { ...styles.body, marginTop: '0px' }}>
      {assessments?.map((assessment: any, aindex: number) => {
        if (Object.keys(assessment?.values)?.length > 0) {
          return assessment?.form?.map((question: any, index: number) => {
            if (
              assessment?.values?.[question.name] ||
              ['title', 'subheader'].includes(question?.itemType)
            ) {
              let printSection = true;
              if (question?.itemType === 'subheader') {
                //look ahead to see if any answers for subheader else don't print
                if (
                  index === assessment?.form?.length - 1 ||
                  assessment?.form?.[index + 1]?.itemType === 'subheader'
                ) {
                  printSection = true;
                } else printSection = false;
                for (let q = index; q < assessment?.form?.length; q++) {
                  if (
                    q > index &&
                    ['title', 'subheader'].includes(
                      assessment?.form?.[q]?.itemType
                    )
                  ) {
                    break;
                  } else if (
                    assessment?.values?.[assessment?.form?.[q]?.name]
                  ) {
                    printSection = true;
                    break;
                  }
                }
              }
              if (printSection) {
                if (question.itemType === 'radio_table') {
                  return (
                    <RadioTable
                      key={index}
                      question={question}
                      values={assessment?.values}
                      gridSize={`${(100 * question?.gridSize) / 12 || 100}%`}
                      debug={debug}
                    />
                  );
                } else {
                  return (
                    <Item
                      key={index}
                      question={question}
                      value={assessment?.values?.[question.name]}
                      gridSize={`${(100 * question?.gridSize) / 12 || 100}%`}
                      debug={debug}
                    />
                  );
                }
              } else {
                return <View key={index} />;
              }
            } else {
              return <View key={index} />;
            }
          });
        } else {
          return <View />;
        }
      })}
    </View>
  );
  if (document) {
    return (
      <Document>
        <Page style={styles.page} wrap>
          {header}
          <JPDFContent />
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `${pageNumber}`}
            fixed
          />
        </Page>
      </Document>
    );
  } else {
    return <JPDFContent />;
  }
};

// some ttf fonts: https://gist.github.com/sadikay/d5457c52e7fb2347077f5b0fe5ba9300
// only ttf supported at time of writing
Font.register({
  family: 'Red Hat Display',
  fonts: [
    {
      src: black,
      fontStyle: 'normal',
      fontWeight: 900,
    },
    {
      fontStyle: 'normal',
      fontWeight: 700,
      src: bold,
    },
    {
      src: medium,
      fontWeight: 500,
      fontStyle: 'normal',
    },
    {
      fontStyle: 'normal',
      fontWeight: 400,
      src: regular,
    },
  ],
});

export default JPDF;
